import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GadgetApiModel } from '../model/api-model/gadget/gadget.api.model';
import { OrderApiModel } from '../model/api-model/order/order.api.model';

@Injectable({
  providedIn: 'root'
})
export class OrderGadgetHttpService {
  constructor(private http: HttpClient) {}

  getGadgets(
    cinemaId: string,
    query?: {
      cardId?: string;
      movieId?: string;
      screeningId?: string;
    }
  ): Observable<GadgetApiModel[]> {
    let params = new HttpParams();
    if (query?.cardId) {
      params = params.set('cardId', query.cardId);
    }
    if (query?.movieId) {
      params = params.set('movieId', query.movieId);
    }
    if (query?.screeningId) {
      params = params.set('screeningId', query.screeningId);
    }

    return this.http.get<GadgetApiModel[]>(`/cinema/${cinemaId}/gadget`, { params });
  }

  putGadgetItem(cinemaId: string, orderId: string, body: { itemId: string; quantity: number }[]): Observable<OrderApiModel> {
    return this.http.put<OrderApiModel>(`/cinema/${cinemaId}/order/${orderId}/gadgetitem`, body);
  }

  patchGadgetItem(cinemaId: string, orderId: string, body: { id: string; itemId: string; quantity: number }[]): Observable<OrderApiModel> {
    return this.http.patch<OrderApiModel>(`/cinema/${cinemaId}/order/${orderId}/gadgetitem`, body);
  }
}
